export var linear = function (t) { return t; };
export var easeInQuad = function (t) { return t * t; };
export var easeOutQuad = function (t) { return t * (2 - t); };
export var easeInOutQuad = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };
export var easeInCubic = function (t) { return t * t * t; };
export var easeOutCubic = function (t) { return (--t) * t * t + 1; };
export var easeInOutCubic = function (t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; };
export var easeInQuart = function (t) { return t * t * t * t; };
export var easeOutQuart = function (t) { return 1 - (--t) * t * t * t; };
export var easeInOutQuart = function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; };
export var easeInQuint = function (t) { return t * t * t * t * t; };
export var easeOutQuint = function (t) { return 1 + (--t) * t * t * t * t; };
export var easeInOutQuint = function (t) { return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; };
